import styled from '@mui/system/styled';

export const Container = styled('div')({
  '& .qr-container': {
    padding: '10px 14px',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
  },
});
